import { Component, ViewEncapsulation, OnInit, ViewContainerRef, ViewChild, ElementRef, ApplicationRef } from '@angular/core';
import { KYMW1704Model } from './kymw1704.model';


import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW0400InputModel } from '../../../commons/kymw04/kymw0400/vo/kymw0400-input.model';
import { KYMW0400Component } from '../../../commons/kymw04/kymw0400/kymw0400.component';
import { KYMW0400OutputModel } from '../../../commons/kymw04/kymw0400/vo/kymw0400-output.model';
import { CommonSetting } from '../../../commons/kymw00/common-setting';
import { FileUploadService, FileAccept } from '../../../commons/kymw02/file-upload/file-upload.service';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';

import { GetBillingNameService } from './api-services/get-billing-name.service';
import { GetImageInfoService } from './api-services/get-image-info.service';
import { GetImageNameService } from './api-services/get-image-name.service';
import { GetPcodeDataService } from './api-services/get-pcode-data.service';
import { GetSupplierNameService } from './api-services/get-supplier-name.service';
import { RegistImageSingleService } from './api-services/regist-Image-single.service';
import { ReplaceImageFileService } from './api-services/replace-image-file.service';
import { ReplaceImageFileUploadService } from './api-services/replace-image-file-upload.service';
import { ImageSingleRegistDataModel } from './vo/image-single-regist-data.model';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';

/**
 * 画像個別登録画面を管理するクラス
 *
 * @export KYMW1704Component
 * @class KYMW1704Component
 */
@Component({
  selector: 'app-kymw1704',
  templateUrl: 'kymw1704.component.html',
  styleUrls: ['kymw1704.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1704Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txt_StartOrderCode', { static: true }) public txt_StartOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txt_EndOrderCode', { static: true }) public txt_EndOrderCode: OrderCodeTextInputComponent;
  @ViewChild('dtf_PhotoSchedule', { static: true }) public dtf_PhotoSchedule: WjInputDate;

  /** 画像プレビュー画像拡張子(png) */
  public readonly KEY_IMAGE_PREVIEW_EXT: string = 'ImagePreviewExt';
  /** 画像ファイルの拡張子(eps) */
  public readonly KEY_IMAGE_FILE_EXT: string = 'ImageFileExt';
  /** CWS画像ファイル拡張子(jpg) */
  public readonly KEY_IMAGE_CWS_EXT: string = 'ImageCWSExt';
  /** 画像ファイル名(小) */
  public readonly KEY_IMAGE_FILE_SMALL: string = 'ImageFileSmall';
  /** 画像ファイル名(中) */
  public readonly KEY_IMAGE_FILE_MIDDLE: string = 'ImageFileMiddle';
  /** 画像ファイル名(大) */
  public readonly KEY_IMAGE_FILE_LARGE: string = 'ImageFileLarge';

  /* ファイル情報*/
  private fileRefList: Array<File>;
  private pngFileRef: File;
  private epsFileRef: File;
  private jpgSFileRef: File;
  private jpgMFileRef: File;
  private jpgLFileRef: File;
  private pngExt: string = <string>'';													// 画像プレビュー画像拡張子(png)
  private epsExt: string = <string>'';													// 画像ファイルの拡張子(eps)
  private jpgExt: string = <string>'';													// CWS画像ファイル拡張子(jpg)

  /** モデル */
  kymw1704Model: KYMW1704Model = new KYMW1704Model();

  /** 入力情報 */
  private imageVO: ImageSingleRegistDataModel = null;

  // 親画面からの連携値
  param: any;

  // ウィンドウを閉じる際の処理
  closeFunction: Function;

  /**
   *Creates an instance of KYMW1704Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1704Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getBillingNameService: GetBillingNameService,
    private getImageInfoService: GetImageInfoService,
    private getImageNameService: GetImageNameService,
    private getPCodeDataService: GetPcodeDataService,
    private getSupplierNameService: GetSupplierNameService,
    private registImageSingleService: RegistImageSingleService,
    private replaceImageFileUploadService: ReplaceImageFileUploadService,
    private replaceImageFileService: ReplaceImageFileService,
    private fileUploadService: FileUploadService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  // eslint-disable-next-line
  public ngOnInit(): void {
    this.componentName = 'KYMW1704';
    this.kymw1704Model.kymw1704Component = this;

    // 値設定
    this.kymw1704Model.endOrderNothing = true;      // 「無期限」のチェック
    this.kymw1704Model.endOrderEqual = false;       // 「今回のみ」のチェックを解除
    this.kymw1704Model.cookingExPublish = false;    // 「調理例掲載区分」のチェックを解除
    this.kymw1704Model.photoSchedule = PlessViewUtilsSub.formatedNowDate('YYYY/MM/DD');  // 撮影予定日の初期表示(システム日付)

    // 非活性
    this.kymw1704Model.endOrderCodeEnabled = false;
    this.kymw1704Model.processInstructEnabled = false;
  }

  /**
   * 画面を閉じる
   *
   * @memberof KYMW1704Component
   */
  public eventClose_ClickHandler(): void {
    this.closeFunction();
  }

  /**
   * 使用開始受注コード値変更時のイベントリスナ
   *  @event イベント
   */
  public eventStartOrderCode_ChangedHandler(): void {

    // 今回のみにチェックがある場合
    if (this.kymw1704Model.endOrderEqual) {
      this.setEndOrderCode(this.kymw1704Model.startOrderCode);
    }
  }

  /**
   * 「無期限」チェック時のイベントリスナ
   *  @event イベント
   */
  public eventEndOrderNothing_CheckHandler(): void {
    // チェックにより表示を変更する。
    if (this.kymw1704Model.endOrderNothing) {
      // 「無期限」がチェックされた場合
      this.kymw1704Model.endOrderCodeEnabled = false;   // 使用終了受注コードを非活性
      this.setEndOrderCode('');
      this.kymw1704Model.endOrderEqual = false;         // 「今回のみ」のチェックを解除
    } else {
      // 「無期限」がチェック解除された場合
      this.kymw1704Model.endOrderCodeEnabled = true;    // 使用終了受注コードを活性
    }
  }

  /**
   * 「今回のみ」チェック時のイベントリスナ
   *  @event イベント
   */
  public eventEndOrderEqual_CheckHandler(): void {
    // チェックにより表示を変更する。
    if (this.kymw1704Model.endOrderEqual) {
      // 「今回のみ」がチェックされた場合
      // 使用終了受注コードを非活性
      this.kymw1704Model.endOrderCodeEnabled = false;
      this.setEndOrderCode(this.kymw1704Model.startOrderCode);

      // 「無期限」のチェックを解除
      this.kymw1704Model.endOrderNothing = false;
    } else {
      // 「今回のみ」がチェック解除された場合
      this.kymw1704Model.endOrderCodeEnabled = true; // 使用終了受注コードを活性
      this.setEndOrderCode('');
    }
  }

  /**
   * 画像名設定ボタン押下時のイベントリスナ
   *  @event イベント
   */
  public eventImageNameSeach_ClickHandler(): void {

    // 入力チェック
    // 所属コンボボックスが未設定の場合
    if (PlessViewUtilsSub.isEmpty(this.kymw1704Model.imageBelongID)) {
      this.dialogService.openAlertGetMessage('W0001', ['所属']);
      return;
    }
    // 画像種別コンボボックスが未設定の場合
    if (PlessViewUtilsSub.isEmpty(this.kymw1704Model.imageType)) {
      this.dialogService.openAlertGetMessage('W0001', ['画像種別']);
      return;
    }

    // Ｐコード情報を取得
    const pCodeInfo: string = this.kymw1704Model.pCode;
    // 所属情報を取得
    const imageBelongID: string = this.kymw1704Model.imageBelongID;

    // 所属を元に入力チェックを行う
    // 1：食品、2：非食品の場合
    if (imageBelongID === '1' || imageBelongID === '2') {
      if (PlessViewUtilsSub.isEmpty(pCodeInfo)) {
        this.dialogService.openAlertGetMessage('E0106', ['「1：食品」「2：非食品」', 'Ｐコード']);
        return;
      }

      // Ｐコード取得設定ステータスを存在チェックに設定
      this.kymw1704Model.pCodeSts = 0;

      // Ｐコードの存在チェックを行う
      this.getPCodeDataService.execute(this.kymw1704Model, this.kymw1704Model.pCode, (serverData: any) => {
        // Ｐコード存在チェックか、値設定でメソッドを振り分け
        if (this.kymw1704Model.pCodeSts !== 1) {
          this.kymw1704Model.checkPCodeData(serverData);
        } else {
          this.kymw1704Model.setPCodeData(serverData);
        }
      });

      return;
    }

    // 3：商品非所属の場合
    if (imageBelongID === '3') {

      // Ｐコードに入力がある場合はエラー
      if (!PlessViewUtilsSub.isEmpty(pCodeInfo)) {
        this.dialogService.openAlertGetMessage('E0113', ['所属とＰコード']);
        return;
      }

      this.getImageNameService.execute(this.kymw1704Model, (serverData: any) => {
        this.kymw1704Model.setImageName(serverData);
      });
    }
  }

  /**
   * Ｐコード該当情報取得後の処理
   */
  public checkPCodeData(): void {
    // 承認状態の値をチェック
    if (this.kymw1704Model.admitStatus != null && this.kymw1704Model.admitStatus === '2') {
      // 承認状態が「2：本登録」の場合、Ｐコード + 画像種別で画像名を設定
      this.kymw1704Model.imageName = this.kymw1704Model.pCode + this.kymw1704Model.imageType;
    } else {
      // 承認状態が「2：本登録」以外の場合、エラーメッセージを設定
      this.dialogService.openAlertGetMessage('E0207', ['Ｐコード', '「2：本登録」前', '画像作成指示']);
    }
  }

  /**
   * 画像種別変更時のイベントリスナ
   * 「画像種別」が「C:調理イメージ」か判定して処理
   *  @event イベント
   */
  public eventImageType_ChangedHandler(): void {
    if (this.kymw1704Model.imageType === 'C') {
      // 「調理指示」コンボボックスを「調理要」にし、活性状態にする。
      // 「調理例掲載区分」をチェック状態にする。
      this.kymw1704Model.processInstruct = '1';
      this.kymw1704Model.processInstructEnabled = true;
      this.kymw1704Model.cookingExPublish = true;
    } else {
      // 「調理指示」コンボボックスを空白にし、非活性状態にする。
      // 「調理例掲載区分」のチェック状態を解除する。
      this.kymw1704Model.processInstruct = '';
      this.kymw1704Model.processInstructEnabled = false;
      this.kymw1704Model.cookingExPublish = false;
    }
  }

  /**
   * サンプル発注先コード入力変更イベントリスナ
   *  @event イベント
   */
  public eventSampleOrderingCode_ChangedHandler(): void {
    // 値変更時
    this.kymw1704Model.sampleSupplierNameKanji = ''; // サンプル発注先コード(名称)をクリア

    if (!PlessViewUtilsSub.isEmpty(this.kymw1704Model.sampleOrderingCode)) {
      this.getSupplierNameService.execute(this.kymw1704Model, this.kymw1704Model.sampleOrderingCode, (serverData: any) => {
        this.kymw1704Model.setSampleOrderingName(serverData);
      });
    }
  }

  /**
   * 請求先コード入力変更イベントリスナ
   *  @event イベント
   */
  public eventBillingCode_ChangedHandler(): void {
    // 値変更時
    this.kymw1704Model.billingSupplierNameKanji = ''; // 請求先コード(名称)をクリア

    if (!PlessViewUtilsSub.isEmpty(this.kymw1704Model.billingCode)) {
      this.getBillingNameService.execute(this.kymw1704Model, this.kymw1704Model.billingCode, (serverData: any) => {
        this.kymw1704Model.setBillingName(serverData);
      });
    }
  }

  /**
   * サンプル発注先コード検索ボタンクリックイベントリスナ
   *  @event イベント
   */
  public eventSamplePrderingSeach_ClickHandler(): void {
    const vo: KYMW0400InputModel = new KYMW0400InputModel();
    vo.supplierFlg = '0';    // サンプル発注先
    // 取引先一覧画面を表示
    this.openKymw0400(vo, (outputVO: KYMW0400OutputModel) => {
      this.kymw1704Model.sampleOrderingCode = outputVO.supplierCode;
      this.kymw1704Model.sampleSupplierNameKanji = outputVO.supplierNameKanji;
    });
  }

  /**
   * 請求先コード検索ボタンクリックイベントリスナ
   *  @event イベント
   */
  public eventBillingSeach_ClickHandler(): void {
    const vo: KYMW0400InputModel = new KYMW0400InputModel();
    vo.supplierFlg = '1';    // 請求先
    // 取引先一覧画面を表示
    this.openKymw0400(vo, (outputVO: KYMW0400OutputModel) => {
      this.kymw1704Model.billingCode = outputVO.supplierCode;
      this.kymw1704Model.billingSupplierNameKanji = outputVO.supplierNameKanji;
    });
  }

  /**
   * 取引先一覧画面を表示する
   *
   * @private
   * @param {KYMW0400InputModel} vo
   * @memberof KYMW1704Component
   */
  private openKymw0400(vo: KYMW0400InputModel, returnFunction: Function) {
    const componentRef = this.dialogService.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0400Parameter = (outputVO: KYMW0400OutputModel) => {
      returnFunction(outputVO);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 設定ボタンクリックイベントリスナ
   */
  public eventUpdate_ClickHandler(): void {
    // 入力情報のチェックを行う
    this.checkRegistInfo();
  }

  /**
   * 画像ファイル検索ボタンクリックイベントリスナ
   */
  public eventImage_ClickHandler(): void {
    // ファイル選択ダイアログを開く
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 選択したファイルの拡張子チェック
      for (let i = Number(0); i < selectedFiles.length; i++) {
        const extension = PlessViewUtilsSub.getExtension(selectedFiles[i].name);
        if (extension !== 'eps' && extension !== 'png' && extension !== 'jpg') {
          this.dialogService.openAlertGetMessage('E0220');
          return;
        }
      }
      this.fileRefList = selectedFiles;
      this.eventFileRef_SELECTHandler();
    }, [FileAccept.EPS, FileAccept.PNG, FileAccept.JPG], true);
  }

  /**
   * ファイル選択ダイアログで選択された情報をチェックする
   * 同ファイル名のPNG、EPSの２つを選択されていない場合エラー
   */
  public eventFileRef_SELECTHandler(): void {
    this.pngExt = CommonSetting.getVal(this.KEY_IMAGE_PREVIEW_EXT);
    this.epsExt = CommonSetting.getVal(this.KEY_IMAGE_FILE_EXT);
    this.jpgExt = CommonSetting.getVal(this.KEY_IMAGE_CWS_EXT);
    const sPrefix: string = CommonSetting.getVal(this.KEY_IMAGE_FILE_SMALL);
    const mPrefix: string = CommonSetting.getVal(this.KEY_IMAGE_FILE_MIDDLE);
    const lPrefix: string = CommonSetting.getVal(this.KEY_IMAGE_FILE_LARGE);

    // チェック処理を行う
    this.pngFileRef = this.getImageFileRef(this.fileRefList, '.' + this.pngExt, '');
    this.epsFileRef = this.getImageFileRef(this.fileRefList, '.' + this.epsExt, '');
    this.jpgSFileRef = this.getImageFileRef(this.fileRefList, '.' + this.jpgExt, sPrefix);
    this.jpgMFileRef = this.getImageFileRef(this.fileRefList, '.' + this.jpgExt, mPrefix);
    this.jpgLFileRef = this.getImageFileRef(this.fileRefList, '.' + this.jpgExt, lPrefix);

    // 2個以上のファイルが選択されたのか
    if (this.fileRefList.length < 2) {
      this.dialogService.openAlertGetMessage('E0223');
      return;
    }
    // PNGファイルが選択されたのか
    if (this.pngFileRef == null) {
      this.dialogService.openAlertGetMessage('E0224', ['png']);
      return;
    }
    // EPSファイルが選択されたのか
    if (this.epsFileRef == null) {
      this.dialogService.openAlertGetMessage('E0224', ['eps']);
      return;
    }
    // 同一名前のファイルが選択されたのか
    if (this.pngFileRef.name.replace('png', '') !== this.epsFileRef.name.replace('eps', '')) {
      this.dialogService.openAlertGetMessage('E0225');
      return;
    }

    // JPGファイルが指定された場合
    if (this.jpgSFileRef !== null || this.jpgMFileRef !== null || this.jpgLFileRef !== null) {

      // JPGファイルは３サイズセットで選択されたか
      if (this.jpgSFileRef == null || this.jpgMFileRef == null || this.jpgLFileRef == null) {
        this.dialogService.openAlertGetMessage('E0508');
        return;
      }

      // 同一名前のファイルが選択されたのか
      if (this.pngFileRef.name.replace('.' + this.pngExt, '')
        !== this.jpgSFileRef.name.replace(sPrefix + '.' + this.jpgExt, '')) {
        this.dialogService.openAlertGetMessage('E0225');
        return;
      }
      // 同一名前のファイルが選択されたのか
      if (this.pngFileRef.name.replace('.' + this.pngExt, '')
        !== this.jpgMFileRef.name.replace(mPrefix + '.' + this.jpgExt, '')) {
        this.dialogService.openAlertGetMessage('E0225');
        return;
      }
      // 同一名前のファイルが選択されたのか
      if (this.pngFileRef.name.replace('.' + this.pngExt, '')
        !== this.jpgLFileRef.name.replace(lPrefix + '.' + this.jpgExt, '')) {
        this.dialogService.openAlertGetMessage('E0225');
        return;
      }
    }

    this.kymw1704Model.tempEPSFileName = '';
    this.kymw1704Model.tempPNGFileName = '';
    this.kymw1704Model.tempJPGSFileName = '';
    this.kymw1704Model.tempJPGMFileName = '';
    this.kymw1704Model.tempJPGLFileName = '';
    this.kymw1704Model.pngFileRef = this.pngFileRef;
    this.kymw1704Model.epsFileRef = this.epsFileRef;
    this.kymw1704Model.jpgSFileRef = this.jpgSFileRef;
    this.kymw1704Model.jpgMFileRef = this.jpgMFileRef;
    this.kymw1704Model.jpgLFileRef = this.jpgLFileRef;
    this.kymw1704Model.imageFile = this.pngFileRef.name;
  }

  /**
   * replaceImageFileUploadService実行
   *
   * @private
   * @param {File} file Upload対象ファイル
   * @param {Function} successFunction 次のクライアント処理関数
   * @memberof KYMW1704Component
   */
  private executeReplaceImageFileUploadService(file: File, successFunction: Function) {
    const vo = { fileRef: file, };
    this.replaceImageFileUploadService.execute(this.kymw1704Model, vo, (data: any) => {
      const pngExt: string = '.' + CommonSetting.getVal(this.KEY_IMAGE_PREVIEW_EXT);
      const jpgExt: string = '.' + CommonSetting.getVal(this.KEY_IMAGE_CWS_EXT);
      const sPrefix: string = CommonSetting.getVal(this.KEY_IMAGE_FILE_SMALL);
      const mPrefix: string = CommonSetting.getVal(this.KEY_IMAGE_FILE_MIDDLE);
      const lPrefix: string = CommonSetting.getVal(this.KEY_IMAGE_FILE_LARGE);
      const tempFileName = data.TempFileName

      if (String(tempFileName).indexOf(pngExt) > 0) {
        this.kymw1704Model.tempPNGFileName = String(tempFileName);
      } else if (String(tempFileName).indexOf(sPrefix + jpgExt) > 0) {
        this.kymw1704Model.tempJPGSFileName = String(tempFileName);
      } else if (String(tempFileName).indexOf(mPrefix + jpgExt) > 0) {
        this.kymw1704Model.tempJPGMFileName = String(tempFileName);
      } else if (String(tempFileName).indexOf(lPrefix + jpgExt) > 0) {
        this.kymw1704Model.tempJPGLFileName = String(tempFileName);
      } else {
        this.kymw1704Model.tempEPSFileName = String(tempFileName);
      }

      // 次のクライアント処理実行
      successFunction();
    });
  }

  /**
   * PNGファイルアップロードイベント
   * @event イベント
   */
  private eventPNGFileRefUploadSUCCESS(): void {
    // 次クライアント処理を「JPG(小)ファイルアップロードイベント」に設定し、PNGファイルアップロード処理を実行
    const file: File = this.kymw1704Model.epsFileRef;
    this.executeReplaceImageFileUploadService(file, () => {
      this.eventJPGSFileRefUploadSUCCESS();
    });
  }

  /**
   * JPG(小)ファイルアップロードイベント
   * @event イベント
   */
  private eventJPGSFileRefUploadSUCCESS(): void {
    if (this.kymw1704Model.jpgSFileRef != null) {
      // 次クライアント処理を「JPG(中)ファイルアップロードイベント」に設定し、JPG(小)ファイルアップロード処理を実行
      const file: File = this.kymw1704Model.jpgSFileRef;
      this.executeReplaceImageFileUploadService(file, () => {
        this.eventJPGMFileRefUploadSUCCESS();
      });
    } else {
      // EPSファイルアップロード処理を実行
      this.eventEPSFileRefUploadSUCCESS();
    }
  }

  /**
   * JPG(中)ファイルアップロードイベント
   * @event イベント
   */
  private eventJPGMFileRefUploadSUCCESS(): void {
    // 次クライアント処理を「JPG(大)ファイルアップロードイベント」に設定し、JPG(中)ファイルアップロード処理を実行
    const file: File = this.kymw1704Model.jpgMFileRef;
    this.executeReplaceImageFileUploadService(file, () => {
      this.eventJPGLFileRefUploadSUCCESS();
    });
  }

  /**
   * JPG(大)ファイルアップロードイベント
   * @event イベント
   */
  private eventJPGLFileRefUploadSUCCESS(): void {
    // 次クライアント処理を「EPSファイルアップロードイベント」に設定し、JPG(大)ファイルアップロード処理を実行
    const file: File = this.kymw1704Model.jpgLFileRef;
    const successFunction = this.eventEPSFileRefUploadSUCCESS;
    this.executeReplaceImageFileUploadService(file, () => {
      this.eventEPSFileRefUploadSUCCESS();
    });
  }

  /**
   * EPSファイルアップロードイベント完了後
   * @event イベント
   */
  private eventEPSFileRefUploadSUCCESS(): void {

    const vo = {
      tempPNGFileName: this.kymw1704Model.tempPNGFileName,
      tempEPSFileName: this.kymw1704Model.tempEPSFileName,
      tempJPGSFileName: this.kymw1704Model.tempJPGSFileName,
      tempJPGMFileName: this.kymw1704Model.tempJPGMFileName,
      tempJPGLFileName: this.kymw1704Model.tempJPGLFileName,
      imageBelongId: this.imageVO.imageBelongID,
      pCode: this.imageVO.pCode,
      imageType: this.imageVO.imageType,
      jpgUpdateFlg: this.imageVO.jpgUpdateFlg,
    };

    // 次クライアント処理を「ファイルアップロード完了イベント」に設定し、EPSファイルアップロード処理を実行
    this.replaceImageFileService.execute(this.kymw1704Model, vo, (data: any) => {
      // 登録された情報を設定
      this.kymw1704Model.imageID = data.ImageID;              // 画像ID
      this.kymw1704Model.imageName = data.ImageName;          // 画像名
      this.kymw1704Model.imageFileName = data.ImageFileName;  // 画像ファイル名
      this.setImageFileInfo(data);

      this.eventReplaceImageFileSUCCESS();
    });
  }

  /**
   * ファイルアップロード完了イベント
   */
  private eventReplaceImageFileSUCCESS(): void {
    this.registImageSingleService.execute(this.kymw1704Model, this.imageVO, () => {
      this.getViewInfo();
    });
  }

  /**
   * イメージファイル名取得
   *
   * @param fileRefList:ファイルリファレンス配列
   * 			type:ファイルタイプ
   * 			prefix:接頭語(S, M, L)
   * @return FileReference
   */
  private getImageFileRef(fileRefList: Array<any>, type: string, prefix: string): any {
    for (let i = Number(0); i < fileRefList.length; i++) {
      if (this.splitExt(fileRefList[i].name) === type) {
        if (type === '.' + this.jpgExt) {
          const sName: string = fileRefList[i].name;
          if (sName.substr(sName.length - (prefix + type).length, (prefix + type).length).toUpperCase() === (prefix + type).toUpperCase()) {
            return fileRefList[i];
          }
        } else {
          return fileRefList[i];
        }
      }
    }
    return null;
  }

  /**
   * 拡張しを取得
   */
  private splitExt(filename: string): string {
    const a = filename.split(/(?=\.[^.]+$)/);
    return a[1];
  }

  /**
   * Ｐコード入力変更イベントリスナ
   *  @event イベント
   */
  public eventPCode_ChangedHandler(): void {
    // 入力情報をクリア
    this.kymw1704Model.guideGoodsName = '';            // 商品案内用商品名をクリア
    this.kymw1704Model.guideStandardName = '';         // 商品案内用規格名をクリア
    this.kymw1704Model.sampleOrderingCode = '';        // サンプル発注先コードをクリア
    this.kymw1704Model.billingCode = '';               // 請求先コードをクリア
    this.kymw1704Model.sampleSupplierNameKanji = '';   // サンプル発注先コード(名称)をクリア
    this.kymw1704Model.billingSupplierNameKanji = '';  // 使請求先コード(名称)をクリア

    if (!PlessViewUtilsSub.isEmpty(this.kymw1704Model.pCode)) {
      // Ｐコード取得設定ステータスを情報取得に設定
      this.kymw1704Model.pCodeSts = 1;

      this.getPCodeDataService.execute(this.kymw1704Model, this.kymw1704Model.pCode, (serverData: any) => {
        // Ｐコード存在チェックか、値設定でメソッドを振り分け
        if (this.kymw1704Model.pCodeSts !== 1) {
          this.kymw1704Model.checkPCodeData(serverData);
        } else {
          this.kymw1704Model.setPCodeData(serverData);
        }
      });
    }
  }

  /**
   * 設定ボタン押下時の入力チェック
   */
  private checkRegistInfo(): void {
    // 入力チェック
    // 画像ファイルが未選択の場合
    if (PlessViewUtilsSub.isEmpty(this.kymw1704Model.imageFile)) {
      this.dialogService.openAlertGetMessage('E0103', ['画像ファイル']);
      return;
    }

    // 入力情報を保持
    this.setRegistImage();

    // 使用開始受注コードが未入力の場合
    if (PlessViewUtilsSub.isEmpty(this.imageVO.startOrderCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['使用開始受注コード']);
      return;
    }

    // 使用開始受注コードが該当がないデータの場合
    if (PlessViewUtilsSub.isEmpty(this.txt_StartOrderCode.selectedCatalogID)) {
      // 項番2473 END   連合会問合せNo.33対応
      this.dialogService.openAlertGetMessage('E0206', ['使用開始受注コード']);
      return;
    }

    // 使用終了受注コードが該当データが無い場合(編集モード対応)
    if (PlessViewUtilsSub.isEmpty(this.txt_EndOrderCode.selectedCatalogID) &&
      !(this.kymw1704Model.endOrderNothing) &&
      !(PlessViewUtilsSub.isEmpty(this.kymw1704Model.endOrderCode))) {
      this.dialogService.openAlertGetMessage('E0206', ['使用終了受注コード']);
      return;
    }

    // 使用開始受注コード、使用終了受注コード共に入力の場合で、
    // 使用開始受注コード ≦ 使用終了受注コードでない場合
    if (!PlessViewUtilsSub.isEmpty(this.imageVO.endOrderCode)
      && Number(this.imageVO.startOrderCode) > Number(this.imageVO.endOrderCode)) {
      this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
      return;
    }

    // エラー対象（チェックボックス関係）↓
    // 使用終了受注コード：入力なし、無期限：チェックなし、endOrderEqual：チェックあり
    // 使用終了受注コード：入力なし、無期限：チェックなし、endOrderEqual：チェックなし
    if ((PlessViewUtilsSub.isEmpty(this.imageVO.endOrderCode) && !this.imageVO.endOrderNothing && this.imageVO.endOrderEqual)
      || (PlessViewUtilsSub.isEmpty(this.imageVO.endOrderCode) && !this.imageVO.endOrderNothing && !this.imageVO.endOrderEqual)) {
      this.dialogService.openAlertGetMessage('W0024', ['「使用終了受注コード」と「無期限」「今回のみ」チェック関係']);
      return;
    }

    // 所属が未選択の場合
    if (PlessViewUtilsSub.isEmpty(this.imageVO.imageBelongID)) {
      this.dialogService.openAlertGetMessage('E0103', ['所属']);
      return;
    }

    // 画像種類が未選択の場合
    if (PlessViewUtilsSub.isEmpty(this.imageVO.imageKind)) {
      this.dialogService.openAlertGetMessage('E0103', ['画像種類']);
      return;
    }

    // 画像種別が未選択の場合
    if (PlessViewUtilsSub.isEmpty(this.imageVO.imageType)) {
      this.dialogService.openAlertGetMessage('E0103', ['画像種別']);
      return;
    }

    // 「撮影予定日」が未入力の場合、以下のメッセージを表示して処理を終了する。
    if (PlessViewUtilsSub.isEmpty(this.kymw1704Model.photoSchedule)) {
      this.dialogService.openAlertGetMessage('E0110', ['撮影予定日']);
      return;
    }

    // 撮影場所が未選択の場合
    if (PlessViewUtilsSub.isEmpty(this.imageVO.photoStudioID)) {
      this.dialogService.openAlertGetMessage('E0103', ['撮影場所']);
      return;
    }

    // 画像種別が「調理イメージ」の場合で、「調理指示」が未選択の場合、以下のメッセージを表示して処理を終了する。
    if (PlessViewUtilsSub.nullToBlank(this.imageVO.imageType) === 'C' &&
      PlessViewUtilsSub.isEmpty(this.imageVO.processInstruct)) {
      this.dialogService.openAlertGetMessage('E0103', ['調理指示']);
      return;
    }

    // 所属が「1：食品」「2：非食品」の場合
    if (this.imageVO.imageBelongID === '1' || this.imageVO.imageBelongID === '2') {
      // Ｐコードが未入力の場合
      if (PlessViewUtilsSub.isEmpty(this.imageVO.pCode)) {
        this.dialogService.openAlertGetMessage('E0106', ['「1：食品」「2：非食品」', 'Ｐコード']);
        return;
      }

      // Ｐコード取得設定ステータスを存在チェックに設定
      this.kymw1704Model.pCodeSts = 2;

      // Ｐコードの存在チェックを行う
      this.getPCodeDataService.execute(this.kymw1704Model, this.imageVO.pCode, (serverData: any) => {
        // Ｐコード存在チェックか、値設定でメソッドを振り分け
        if (this.kymw1704Model.pCodeSts !== 1) {
          this.kymw1704Model.checkPCodeData(serverData);
        } else {
          this.kymw1704Model.setPCodeData(serverData);
        }
      });

      // 所属が「3：商品非所属」の場合
    } else if (this.imageVO.imageBelongID === '3') {

      // Ｐコードが入力されている場合
      if (!PlessViewUtilsSub.isEmpty(this.imageVO.pCode)) {
        this.dialogService.openAlertGetMessage('E0113', ['所属とＰコード']);
        return;
      }

      // 請求先が未入力で、請求対象がチェックされている場合
      if (PlessViewUtilsSub.isEmpty(this.imageVO.billingCode) && this.imageVO.billingTargetDiv === '1') {
        this.dialogService.openAlertGetMessage('E0210', ['請求先', '未入力', '請求対象', '指定']);
        return;
      }
      this.registMessage();
    }
  }

  /**
   * Ｐコード該当情報取得後の処理
   */
  public checkPCodeRegist(): void {
    // 承認状態の値をチェック
    if (this.kymw1704Model.admitStatus != null && this.kymw1704Model.admitStatus === '2') {
      this.registMessage();
    } else {
      this.dialogService.openAlertGetMessage('E0207', ['Ｐコード', '「2：本登録」前', '画像個別登録']);
      return;
    }
  }

  /**
   * Ｐコード該当情報取得後の処理
   */
  public registMessage(): void {

    // サンプル発注コードが未入力の場合
    if (PlessViewUtilsSub.isEmpty(this.imageVO.sampleOrderingCode) && this.imageVO.imageBelongID !== '3') {
      this.dialogService.openAlertGetMessage('E0106', ['「1：食品」「2：非食品」', 'サンプル発注先コード']);
      return;
    }

    // 請求先コードが未入力の場合
    if (PlessViewUtilsSub.isEmpty(this.imageVO.billingCode) && this.imageVO.imageBelongID !== '3') {
      this.dialogService.openAlertGetMessage('E0106', ['「1：食品」「2：非食品」', '請求先コード']);
      return;
    }

    // 登録確認メッセージを表示
    this.dialogService.openAlertGetMessage('Q0104', ['画像情報管理'], (closeDetail) => {
      // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
      if (closeDetail === PlessAlert.Yes) {
        this.insertImage();
      }
    });
  }

  /**
   * 画像ファイルをワーク領域へアップロードし、登録処理を行う。
   * 要求ID：/KYMW0C/registImageInfo.xml
   */
  private insertImage(): void {
    // 画像ファイル（PNG）を、サーバのワーク領域へアップロードする。
    const file: File = this.kymw1704Model.pngFileRef;
    this.executeReplaceImageFileUploadService(file, () => {
      this.eventPNGFileRefUploadSUCCESS();
    });
  }

  /**
   * 表示情報を画像ＩＤより取得し再表示する。
   * 要求ID：/KYMW0C/getImageInfo.xml
   */
  public getViewInfo(): void {
    // /KYMW0C/getImageInfo.xmlより、画面表示情報を取得し、設定
    this.getImageInfoService.execute(this.kymw1704Model, this.kymw1704Model.imageID, (serverData: any) => {
      this.kymw1704Model.setImageInfo(serverData);
    });
  }

  /**
   * 現在入力されている情報を保持
   */
  private setRegistImage(): void {
    this.imageVO = new ImageSingleRegistDataModel();
    this.imageVO.imageFilePNG = this.kymw1704Model.pngFileRef.name;                  // 画像ファイル(PNG)
    this.imageVO.imageFileEPS = this.kymw1704Model.epsFileRef.name;                  // 画像ファイル(EPS)
    this.imageVO.startOrderCode = this.kymw1704Model.startOrderCode;                     // 使用開始受注コード
    this.imageVO.endOrderNothing = this.kymw1704Model.endOrderNothing;                // 無期限
    this.imageVO.endOrderEqual = this.kymw1704Model.endOrderEqual;                    // 使今回のみ
    this.imageVO.imageBelongID = this.kymw1704Model.imageBelongID;           // 画像所属
    this.imageVO.imageKind = this.kymw1704Model.imageKind;                   // 画像種類
    this.imageVO.imageType = this.kymw1704Model.imageType;                   // 画像種別
    this.imageVO.processInstruct = this.kymw1704Model.processInstruct;       // 加工指示
    this.imageVO.pCode = this.kymw1704Model.pCode;                                       // Ｐコード
    this.imageVO.sampleOrderingCode = this.kymw1704Model.sampleOrderingCode;             // サンプル発注先コード
    this.imageVO.billingCode = this.kymw1704Model.billingCode;                           // 請求先コード
    this.imageVO.cookingDiv = this.kymw1704Model.cookingDiv;                 // 料理分類
    this.imageVO.cookingName = this.kymw1704Model.cookingName;                           // 料理名
    this.imageVO.materialName = this.kymw1704Model.materialName;                         // 材料名
    this.imageVO.keyWord = this.kymw1704Model.keyWord;                                   // キーワード
    this.imageVO.eventID = this.kymw1704Model.eventID;                       // 季節・催事
    this.imageVO.remarks = this.kymw1704Model.remarks;                                   // 備考
    this.imageVO.photoContentsDiv = this.kymw1704Model.photoContentsDiv;     // 撮影内容区分
    this.imageVO.photoInstructContents = this.kymw1704Model.photoInstructContents;       // 掲載指示内容
    this.imageVO.photoSchedule = PlessViewUtilsSub.editDate(this.kymw1704Model.photoSchedule, '1'); // 撮影予定日
    this.imageVO.photoStudioID = this.kymw1704Model.studioId;            // 撮影場所
    this.imageVO.textCaption = this.kymw1704Model.textCaption;                               // 画像キャプション

    // 使用終了受注コードを設定
    this.imageVO.endOrderCode = (this.kymw1704Model.endOrderNothing) ? '9999999' : this.kymw1704Model.endOrderCode;

    // 調理例掲載区分のチェックで値を変更
    if (this.kymw1704Model.cookingExPublish) {
      this.imageVO.cookingExPublish = '1';
    } else {
      this.imageVO.cookingExPublish = '0';
    }

    // 請求対象のチェックで値を変更
    if (this.kymw1704Model.billingTargetDiv) {
      this.imageVO.billingTargetDiv = '1';
    } else {
      this.imageVO.billingTargetDiv = '0';
    }

    // JPGファイルリファレンスのチェック
    // JPGファイルが指定されている場合
    if (this.jpgSFileRef != null && this.jpgMFileRef != null && this.jpgLFileRef != null) {
      // JPGファイル更新フラグ(1:更新要)
      this.imageVO.jpgUpdateFlg = ImageSingleRegistDataModel.JPG_UPDATE_FLG_ON;
      // PGファイルが指定されてない場合
    } else {
      // JPGファイル更新フラグ(0:更新否)
      this.imageVO.jpgUpdateFlg = ImageSingleRegistDataModel.JPG_UPDATE_FLG_OFF;
    }
  }

  /**
   * 画像ファイル情報を保持
   */
  public setImageFileInfo(obj: any): void {
    this.imageVO.imageId = obj.ImageID;
    this.imageVO.imageName = (PlessViewUtilsSub.isEmpty(obj.ImageName)) ? '' : obj.ImageName;
    this.imageVO.imageNameBranch = (PlessViewUtilsSub.isEmpty(obj.ImageNameBranch)) ? '' : obj.ImageNameBranch;
    this.imageVO.imageFileName = (PlessViewUtilsSub.isEmpty(obj.ImageFileName)) ? '' : obj.ImageFileName;
  }

  /**
   * 『取引先一覧』画面（KYMW0400）の戻り
   */
  public setKYMW0400Parameter(outputVO: KYMW0400OutputModel): void {
    // 『取引先一覧』画面（KYMW0400）を呼び出し、取引先を選択する。
    // サンプル発注先
    if (outputVO.supplierFlg === '0') {
      this.kymw1704Model.sampleOrderingCode = outputVO.supplierCode;
      this.kymw1704Model.sampleSupplierNameKanji = outputVO.supplierNameKanji;
    } else if (outputVO.supplierFlg === '1') {
      this.kymw1704Model.billingCode = outputVO.supplierCode;
      this.kymw1704Model.billingSupplierNameKanji = outputVO.supplierNameKanji;
    }
  }

  /**
   * 指定された受注コードで終了受注コードと使用終了配達企画回(翌週)を更新する。
   * また、自動セットされた場合に終了受注コードと使用終了配達企画回(翌週)のバインド変数に
   * 値がセットされないため明示的にセットする
   *
   * @private
   * @param {string} orderCode
   * @memberof KYMW1704Component
   */
  private setEndOrderCode(orderCode: string) {
    this.kymw1704Model.endOrderCode = orderCode;
  }

}
